jQuery(document).ready(function ($) {
  
  $(document).on("click", ".atc-custom-ajax", function (e) {
    e.preventDefault();
    this.cartNotification =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];
    const formData = new FormData(this.form);
    if (this.cartNotification) {
      formData.append(
        "sections",
        this.cartNotification.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
      this.cartNotification.setActiveElement(document.activeElement);
    }
    config.body = formData;
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          return;
        }
        this.cartNotification.renderContents(response);
        this.cartNotification.classList.remove("is-empty");
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {});
  });

  $(document).on("click", ".var-47169966178651", function (e) {
    if (e.hasOwnProperty("originalEvent") == true) {
      $(".freegifremoved").val(1);
    }
  });
});
